import request from '@/utils/request'
/**
 * 用户名和密码登录
 * @param {Object} data
 */
export function login(data) {
  return request({
    url: 'sso/login/login',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    isLoading: true
  })
}

/**
 * 获取token
 * @param {Object} data
 */
export function getToken(data) {
  return request({
    url: 'sso/login/token',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    isLoading: false
  })
}

/**
 * 获取用户信息
 * @param {Object} data
 */
export function getUserInfo() {
  return request({
    url: 'sso/login/userInfo',
    method: 'post',
    // data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    isLoading: false
  })
}

/**
 * 飞书js-sdk鉴权信息
 * @param {Object} data
 */
export function getFsJsApiSignature(data) {
  return request({
    url: `ThirdPartySystem/fs/getFsJsApiSignature?url=${data}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    isLoading: false
  })
}

